import { EventModelSize } from '../types';

export const formatModelSizes = (sizes: EventModelSize[]) => {
  const result = sizes.reduce((acc, { sizeId, quantity }) => {
    const existing = acc.find((item) => item.sizeId === sizeId);
    const quantityNumber = parseInt(quantity, 10);

    if (existing) {
      existing.quantity += quantityNumber;
    } else {
      acc.push({ sizeId, quantity: quantityNumber });
    }

    return acc;
  }, []);

  return result;
};
